/**
 *
 * KExplorer is a tool internally developed by KPMG to allow web pages to
 * access local Windows apps such as File Exporer.
 *
 * Converts input of file:// link into a kexplore link (used by Rubix France team)
 * This would only transform if uiconfig.kExplorerViewer is set to true.
 */
import { Pipe, PipeTransform } from "@angular/core";
// import { DomSanitizer } from '@angular/platform-browser';
import { ConfigStateService } from "../../app/config/config-state.service";
import { TenantConfigService } from "../services/tenant-config.service";

@Pipe({
    name: "KExplorer",
    standalone: false
})
export class KExplorerPipe implements PipeTransform {

  //constructor(private domSanitizer: DomSanitizer, private config: ConfigStateService) {}
  constructor(private config: ConfigStateService) {}

  transform(url: string): string {
    const uiConfig = new TenantConfigService(this.config);
    const fileProtocolRegex = /^file:/;
//    if (uiConfig.config.kExplorerViewer && url && fileProtocolRegex.test(url)) {
//      const kexploreUrl = decodeURIComponent(url
//        .replace(fileProtocolRegex, "KExplorer:Explorer-")
//        .replace(/\//g, "\\"));
//      // @ts-ignore
//      return this.domSanitizer.bypassSecurityTrustResourceUrl(kexploreUrl);
//    }
    return url;
  }
}
